import React, {useEffect, useRef, useState} from 'react'
import Select from 'react-select'
import {KTSVG} from "../../../../_metronic/helpers";
import {editMultipleReferentielTypePiece} from "../../../../components/requests";
import {toast} from "react-toastify";
import {potInitValues} from "../../../../components/Models";

const LierReferentielSiteModal = (props) => {
  const {allTypePiece, sites, setDataReferentielTypePiece} = props

  const modalRef = useRef<any>(null)
  const refClose = useRef<any>(null)

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [typePieceData, setTypePieceData] = useState<any>([])
  const [siteData, setSiteData] = useState<any>([])

  const typePieces = allTypePiece?.map((typePiece) => ({
    value: typePiece?.idTypePiece,
    label: typePiece?.nomTypePiece,
  }))

  const editMultipleReferentiels = () => {
    setIsLoading(true)
    const idToast = toast.loading('Liaison en cours...')
    const typePiecePayload = typePieceData?.map((typePiece) => typePiece?.value)
    const sitePayload = siteData?.map((site) => ({
      id: site?.value,
      nom: site?.label,
    }))
    editMultipleReferentielTypePiece(typePiecePayload, sitePayload)
      .then((response) => {
        if (response?.data !== undefined) {
          if (setDataReferentielTypePiece) setDataReferentielTypePiece((prev) => prev?.map((piece) => {
            const updatedReferentielTypePiece = response?.data?.find((
              (item) => (item?.id === piece?.idRefTypePiece || item?.typePiece?.nom === piece?.nomTypePiece)
            ))
            if (updatedReferentielTypePiece) return {
              ...piece,
              sites: updatedReferentielTypePiece?.sites
            }
            return piece
          }))
          toast.update(idToast, {
            render: 'Referentiel type pièce modifié avec succès.',
            type: 'success',
            isLoading: false,
            autoClose: 3000,
          })
          if (refClose) refClose?.current?.click()
        }
      })
      .catch(() => {
        toast.update(idToast, {
          render: 'Erreur durant la modification du referentiel type pièce.',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    const modal = modalRef.current

    if (!modal) return

    const handleShown = () => {}

    const handleHidden = () => {
      setTypePieceData([])
      setSiteData([])
    }

    // Ouverture complète du modal
    modal.addEventListener('shown.bs.modal', handleShown)

    // Fermeture complète du modal
    modal.addEventListener('hidden.bs.modal', handleHidden)

    // Cleanup
    return () => {
      modal.removeEventListener('shown.bs.modal', handleShown)
      modal.removeEventListener('hidden.bs.modal', handleHidden)
    }
  }, [])

  return (
    <div className='modal fade' tabIndex={-1} id='referentielSiteModal' ref={modalRef}>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Lier à un site</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              ref={refClose}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <div className='mb-4'>
              <Select
                isClearable
                isMulti
                closeMenuOnSelect={false}
                className='react-select-styled react-select-solid react-select-lg'
                classNamePrefix='react-select'
                options={typePieces}
                fieldName='motif_refus'
                value={typePieceData}
                onChange={(value) => setTypePieceData(value)}
                placeholder='Selectionner les types pièces'
              />
            </div>
            <div>
              <Select
                isClearable
                isMulti
                closeMenuOnSelect={false}
                className='react-select-styled react-select-solid react-select-lg'
                classNamePrefix='react-select'
                options={sites}
                fieldName='motif_refus'
                value={siteData}
                onChange={(value) => setSiteData(value)}
                placeholder='Selectionner les sites'
              />
            </div>
          </div>
          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-light'
              data-bs-dismiss='modal'
            >
              Retour
            </button>
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => editMultipleReferentiels()}
              disabled={isLoading || typePieceData?.length === 0}
            >
              {(!isLoading) ? 'Lier' : 'Liaison en cours...'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LierReferentielSiteModal
